import { Injectable } from "@angular/core";
import { MatBottomSheet, MatBottomSheetConfig, MatBottomSheetRef } from "@angular/material";
import { ComponentType } from "@angular/core/src/render3";
import { ClientType } from "./com/comEnvironmentClient";
import { CoreCOMService } from "./com.service";

@Injectable({
  providedIn: "root"
})
export class BottomSheetHelperService {

  constructor(private _bottomSheet: MatBottomSheet
    , private _coreCOMService: CoreCOMService) {

  }
  public open(component: any, config?: any): MatBottomSheetRef {
    const me = this;
    const bottomSheetRef = me._bottomSheet.open(component, config);
    // define subscriber in IOS to avoid page scrolling when a modal is open
    if (me._coreCOMService.environment.client.type === ClientType.ios) {
      bottomSheetRef.afterOpened().subscribe(() => {
        me.lockPageForIOS(true);
      });

      bottomSheetRef.afterDismissed().subscribe(() => {
        me.lockPageForIOS(false);
      });
    }
    return bottomSheetRef;
  }

  /**
   * stop page scrolling when modalDialog is open(IOS problem)
   */
  private lockPageForIOS(isModalOpen: boolean) {
    const containerElement: HTMLElement = document.getElementById("matDrawerContainer");
    if (isModalOpen) {
      containerElement.classList.add("ios-touch-scrolling-disabled");
    } else {
      containerElement.classList.remove("ios-touch-scrolling-disabled");
    }
  }
}
